import { useLocation, useNavigate } from "react-router-dom";
import { tv } from "tailwind-variants";

const drawerNavItem = tv({
  base: "w-full rounded-lg px-4 py-3 text-left text-base font-medium transition-colors",
  variants: {
    isActive: {
      true: "bg-placebo-lavender text-indigo",
      false: "text-soft-gray hover:bg-lavender-mist hover:text-indigo",
    },
  },
});

interface AdminMobileNavItemProps {
  path: string;
  title: string;
  onClose: () => void;
}

export const AdminMobileNavItem = ({
  path,
  title,
  onClose,
}: AdminMobileNavItemProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname.startsWith(path);

  const handleClick = () => {
    navigate(path);
    onClose();
  };

  return (
    <button onClick={handleClick} className={drawerNavItem({ isActive })}>
      {title}
    </button>
  );
};
